import { gettext } from '@eventbrite/i18n';
import { Divider } from '@eventbrite/marmalade';
import React from 'react';

import { Location } from '../../../../../types';
import { MapWithStaticPlaceholder } from '../../Map/MapWithStaticPlaceholder';
import { HowToGetThereButtons } from './HowToGetThereButtons';

import styles from './Location.module.scss';

export type InPersonEventLocationProps = {
    venueMultilineAddress?: string[];
    venueName?: string;
    location: Location;
    hasMap?: boolean;
    gMapsApiKey: string;
};

const Directions = ({ location }: { location: Location }) => {
    return (
        <div className={styles.directions}>
            <Divider className={styles.desktopDivider} />
            <h3 className={styles.directions__heading}>
                {gettext('How do you want to get there?')}
            </h3>
            <HowToGetThereButtons
                className={styles.directions__buttons}
                location={location}
            />
        </div>
    );
};

const MapSection = ({
    location,
    gMapsApiKey,
    hasMap,
}: {
    location: Location;
    gMapsApiKey: string;
    hasMap?: boolean;
}) => {
    if (!hasMap) {
        return null;
    }

    return (
        <div className={styles.mapSection}>
            <MapWithStaticPlaceholder
                location={location}
                gMapsApiKey={gMapsApiKey}
            />
        </div>
    );
};

export const InPersonEventLocation = ({
    venueMultilineAddress,
    venueName,
    location,
    hasMap,
    gMapsApiKey,
}: InPersonEventLocationProps) => {
    const MultiLinesAddressComponent = () => {
        if (!venueMultilineAddress) {
            return null;
        }

        const [firstAddressLine, ...restAddressLines] =
            venueMultilineAddress || [];
        const restOfAddress = restAddressLines?.join(' ');

        return (
            <>
                {firstAddressLine && (
                    <p className={styles.addressAdditionalLine}>
                        {firstAddressLine}
                    </p>
                )}
                {restOfAddress && (
                    <p className={styles.addressAdditionalLine}>
                        {restOfAddress}
                    </p>
                )}
            </>
        );
    };

    return (
        <div className={styles.inPersonContainer}>
            <div className={styles.addressWrapper}>
                {venueName && <p className={styles.addressText}>{venueName}</p>}
                <MultiLinesAddressComponent />
            </div>
            <MapSection
                hasMap={hasMap}
                location={location}
                gMapsApiKey={gMapsApiKey}
            />
            <Directions location={location} />
        </div>
    );
};
